import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import { Dimmer } from "../components/spinner";
import useTable from "../components/useTable";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import axios from "axios";
import useTableScroll from "../components/useTableScroll.js";

const CatalogoResponExpendio = (props) => {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const btnCancela = useRef();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [itemSelect, setItemSelect] = useState(-1);

  const headCells = [
    { label: "CÉDULA", textAlign: "center" },
    { label: "APELLIDOS", textAlign: "center" },
    { label: "NOMBRES", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.cedula.includes(target.value) ||
              x.apellidos.toLowerCase().includes(target.value.toLowerCase()) ||
              x.nombres.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarPersonasTodas = () => {
    let endpoint = `${op.conexion}/api/catalogo/personas`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          var perso = [];
          for (let i = 0; i < response.data.length; i++) {
            perso.push({
              cedula: response.data[i].cedula,
              nombres: response.data[i].nombres,
              apellidos: response.data[i].apellidos,
              correoe: response.data[i].correoe,
              tlf1: response.data[i].tlf1,
              tlf2: response.data[i].tlf2,
              fnacimiento: response.data[i].fnacimiento,
              nacionalidad: response.data[i].nacionalidad,
              sexo: response.data[i].sexo,
              direccion: response.data[i].direccion,
            });
          }
          setRecords(perso);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setItemSelect("");
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setActivo(true);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelaCatPer();
  };

  const seleccionarPersona = (index) => (event) => {
    var ced = values[0].ced;
    var corr = values[0].corr;
    var tlf1 = values[0].tlf1;
    var tlf2 = values[0].tlf2;
    var ape = values[0].ape;
    var direc = values[0].direc;
    var fcn = values[0].fcn;
    var nac = values[0].nac;
    var nom = values[0].nom;
    var sex = values[0].sex;

    blanquear();
    props.onHideAceptaCatPer(
      ced,
      corr,
      tlf1,
      tlf2,
      ape,
      direc,
      fcn,
      nac,
      nom,
      sex
    );
  };

  const seleccionarFila = (index) => (event) => {
    setActivo(false);
    setItemSelect(index);
    var ced = recordsAfterPagingAndSorting()[index].cedula;
    var nom = recordsAfterPagingAndSorting()[index].nombres;
    var ape = recordsAfterPagingAndSorting()[index].apellidos;
    var corr = recordsAfterPagingAndSorting()[index].correoe;
    var tlf1 = recordsAfterPagingAndSorting()[index].tlf1;
    var tlf2 = recordsAfterPagingAndSorting()[index].tlf2;
    var fcn = recordsAfterPagingAndSorting()[index].fnacimiento;
    var nac =
      recordsAfterPagingAndSorting()[index].nacionalidad !== null
        ? recordsAfterPagingAndSorting()[index].nacionalidad.trim()
        : "";
    var sex =
      recordsAfterPagingAndSorting()[index].sexo !== null
        ? recordsAfterPagingAndSorting()[index].sexo.trim()
        : "";
    var direc = recordsAfterPagingAndSorting()[index].direccion;

    var datos = [];
    datos.push({
      ced,
      nom,
      ape,
      corr,
      tlf1,
      tlf2,
      fcn,
      nac,
      sex,
      direc,
    });
    setValues(datos);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarPersonasTodas();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Seleccionar Persona</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="row col-md-12" style={{ marginBottom: "2px" }}>
          <div className="input-group col-md-4 input-group-sm mb-3">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control"
            />
            <button className="btn btn-info" style={{ pointerEvents: "none" }}>
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.cedula}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.apellidos}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.nombres}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={seleccionarPersona()}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
    </Modal>
  );
};

export default CatalogoResponExpendio;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoRspnExp.js